import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { hostClass as hostClass$1 } from '../Grid/Grid.styles.js';
import { hostClass } from './GridColumn.styles.js';

var getGridColumnClasses = function getGridColumnClasses(_ref) {
  var _cleanupClassObject;

  var className = _ref.className,
      size = _ref.size,
      md = _ref.md,
      sm = _ref.sm,
      xs = _ref.xs;
  return cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, "".concat(hostClass), true), _defineProperty(_cleanupClassObject, "".concat(hostClass$1, "__md-col ").concat(hostClass$1, "__md-col-").concat(md !== null && md !== void 0 ? md : size), true), _defineProperty(_cleanupClassObject, "".concat(hostClass$1, "__sm-col ").concat(hostClass$1, "__sm-col-").concat(sm !== null && sm !== void 0 ? sm : size), true), _defineProperty(_cleanupClassObject, "".concat(hostClass$1, "__xs-col ").concat(hostClass$1, "__xs-col-").concat(xs !== null && xs !== void 0 ? xs : size), true), _cleanupClassObject));
};

var getGridColumnInnerClasses = function getGridColumnInnerClasses(_ref2) {
  var _cleanupClassObject2;

  var horizontalAlignment = _ref2.horizontalAlignment,
      horizontalAlignmentXs = _ref2.horizontalAlignmentXs,
      horizontalAlignmentSm = _ref2.horizontalAlignmentSm,
      horizontalAlignmentMd = _ref2.horizontalAlignmentMd;
  return cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass$1, "__align-").concat(horizontalAlignment), !!horizontalAlignment), _defineProperty(_cleanupClassObject2, "".concat(hostClass$1, "__align-xs-").concat(horizontalAlignmentXs), !!horizontalAlignmentXs), _defineProperty(_cleanupClassObject2, "".concat(hostClass$1, "__align-sm-").concat(horizontalAlignmentSm), !!horizontalAlignmentSm), _defineProperty(_cleanupClassObject2, "".concat(hostClass$1, "__align-md-").concat(horizontalAlignmentMd), !!horizontalAlignmentMd), _cleanupClassObject2));
};

var GridColumnPresentation = fComp(function (_a) {
  var id = _a.id,
      children = _a.children,
      style = _a.style,
      elementRef = _a.elementRef,
      isStencilHost = _a.isStencilHost,
      otherProps = __rest(_a, ["id", "children", "style", "elementRef", "isStencilHost"]);

  return /*#__PURE__*/React.createElement(Host, {
    className: getGridColumnClasses(otherProps),
    style: style,
    id: id,
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement("div", {
    className: getGridColumnInnerClasses(otherProps),
    ref: elementRef
  }, children));
});

export { GridColumnPresentation, getGridColumnClasses, getGridColumnInnerClasses };
